import { useState, useEffect } from 'react';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isAuthenticated: boolean;
  isStaff: boolean;
  isSuperuser: boolean;
  role?: string | null;
}

interface Tenant {
  id: string | null;
  name: string;
  subdomain: string;
}

interface AuthState {
  user: User | null;
  tenant: Tenant | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export function useAuth(): AuthState {
  const [authState, setAuthState] = useState<AuthState>({
    user: null,
    tenant: null,
    isLoading: true,
    isAuthenticated: false,
  });

  useEffect(() => {
    // Check authentication status on mount
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch('/api/me/', {
        method: 'GET',
        credentials: 'include', // Important for session cookies
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setAuthState({
          user: data.user,
          tenant: data.tenant,
          isLoading: false,
          isAuthenticated: data.user?.isAuthenticated || false,
        });
      } else if (response.status === 401) {
        // Not authenticated - redirect to Django login
        window.location.href = '/accounts/login/';
      } else {
        // Other error
        setAuthState({
          user: null,
          tenant: null,
          isLoading: false,
          isAuthenticated: false,
        });
      }
    } catch (error) {
      console.error('Authentication check failed:', error);
      setAuthState({
        user: null,
        tenant: null,
        isLoading: false,
        isAuthenticated: false,
      });
    }
  };

  return authState;
}
